import api from "../../api/index";

const getalarms = `${process.env.VUE_APP_BASE_URI}/alarms`;

const addfencealarm = `${process.env.VUE_APP_BASE_URI}/alarms/geofence`;
const addvaluealarm = `${process.env.VUE_APP_BASE_URI}/alarms/value`;
const deleteAlarm = `${process.env.VUE_APP_BASE_URI}/alarms`;
const updatevaluealarm = `${process.env.VUE_APP_BASE_URI}/alarms/value`;
const updatefenceealarm = `${process.env.VUE_APP_BASE_URI}/alarms/geofence`;
const alarmExcursions = `${process.env.VUE_APP_BASE_URI}/alarms`;
const alarms = `${process.env.VUE_APP_BASE_URI}/alarms`;

const getDefaultState = () => {
  return {
    alarms: [],
    alarm: {},
    status: "",
    alarmsMeta: {},
    alarmExcursions: [],
    alarmExcursionsMeta: {},
  };
};

const state = getDefaultState();

const getters = {
  alarms: (state) => state.alarms,
  alarm: (state) => state.alarm,
  alarmsMeta: (state) => state.alarmsMeta,
  alarmExcursions: (state) => state.alarmExcursions,
  alarmExcursionsMeta: (state) => state.alarmExcursionsMeta,
};

const actions = {
  async getalarms({ commit }, params) {
    commit("getalarms_request");
    const res = await api.get(getalarms, { params });
    if (res.data.success) {
      commit("getalarms_success", res.data.payload);
    }
    return res;
  },
  async addAlarm({ commit }, data) {
    commit("getalarms_request");
    const res = await api.post(getalarms, data);
    if (res.data.success) {
      commit("getalarms_success", res.data.payload);
    }
    return res;
  },

  async getAlarmById({ commit }, id) {
    commit("getalarm_request");
    const res = await api.get(`${getalarms}/${id}`);
    if (res.data.success) {
      commit("getalarm_success", res.data.payload);
    }
    return res;
  },

  async addFenceAlarm({ commit }, newFence) {
    commit("addfence_request");
    const res = await api.post(addfencealarm, newFence);
    if (res.data.success) {
      commit("addfence_success");
    }
    return res;
  },

  async addValueAlarm({ commit }, newValue) {
    commit("addvalue_request");
    const res = await api.post(addvaluealarm, newValue);
    if (res.data.success) {
      commit("addvalue_success");
    }
    return res;
  },

  async updateAlarm({ commit }, { id, newValue }) {
    commit("updatevalue_request");
    const res = await api.patch(`${alarms}/${id}`, newValue);
    if (res.data.success) {
      commit("updatevalue_success");
    }
    return res;
  },
  async updateFenceAlarm({ commit }, { id, newValue }) {
    commit("updatefence_request");
    const res = await api.put(`${updatefenceealarm}/${id}`, newValue);
    if (res.data.success) {
      commit("updatefence_success");
    }
    return res;
  },

  async deleteAlarm({ commit }, id) {
    commit("delete_request");
    const res = await api.delete(`${deleteAlarm}/${id}`);
    if (res.data.success) {
      commit("delete_success");
    }
    return res;
  },

  async snoozeAlarms() {
    const res = await api.put(`${deleteAlarm}`);
    return res;
  },
  async snoozeAlarm(_, { id, data }) {
    console.log(id, "snooze");
    const res = await api.patch(`${alarms}/${id}/snooze`, data);
    return res;
  },

  async resetAlarmsState({ commit }) {
    await commit("resetalarmsstate_success");
  },

  async getAlarmExcursions({ commit }, { params, id }) {
    commit("getalarmexcursions_request");
    const res = await api.get(`${alarmExcursions}/${id}/excursions`, {
      params,
    });
    if (res.data.success) {
      console.log(res.data.payload, "res.data.payload)");
      commit("getalarmexcursions_success", res.data.payload);
    }
    return res;
  },
};

const mutations = {
  getalarms_request: (state) => (state.status = "loading"),
  getalarms_success: (state, alarms) => {
    state.status = "success";
    state.alarms = alarms.data;
    state.alarmsMeta = alarms.meta;
  },
  getalarm_request: (state) => (state.status = "loading"),
  getalarm_success: (state, alarm) => {
    state.status = "success";
    state.alarm = alarm;
  },

  addfence_request: (state) => (state.status = "loading"),
  addfence_success: (state) => (state.status = "success"),

  updatevalue_request: (state) => (state.status = "loading"),
  updatevalue_success: (state) => (state.status = "success"),

  delete_request: (state) => (state.status = "loading"),
  delete_success: (state) => (state.status = "success"),

  updatefence_request: (state) => (state.status = "loading"),
  updatefence_success: (state) => (state.status = "success"),

  addvalue_request: (state) => (state.status = "loading"),
  addvalue_success: (state) => (state.status = "success"),

  getalarmexcursions_request: (state) => (state.status = "loading"),
  getalarmexcursions_success: (state, alarm) => {
    state.status = "success";
    state.alarmExcursions = alarm.data;
    state.alarmExcursionsMeta = alarm.meta;
  },

  resetalarmsstate_success: (state) => Object.assign(state, getDefaultState()),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
